/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { BaseFeatureMock } from '../mockServer/featureMock';
import { delayedDownloadingListItemFactory } from './downloadingsFactories';
import { DelayedDownloadingsListItemDto } from './downloadingsClient.typings';

const DELAYED_DOWNLOADS: RegExp = /\/downloads$/;
const GET_URL_FOR_DOWNLOADING: RegExp = /\/downloads\/url/;

class DownloadingsMock extends BaseFeatureMock {
    public readonly getUrlForDownloading = this.route<string>({
        method: 'get',
        url: GET_URL_FOR_DOWNLOADING,
        defaultResponse: (config) => `http://someUrl/${config.params.name}`,
        delayMs: () => Math.random() * 1000,
    });

    public readonly list = this.route<DelayedDownloadingsListItemDto[]>({
        method: 'get',
        url: DELAYED_DOWNLOADS,
        defaultResponse: () => delayedDownloadingListItemFactory.list({ count: 15 }),
        delayMs: () => Math.random() * 1000,
    });

    public readonly deleteItems = this.route<'OK'>({
        method: 'delete',
        url: DELAYED_DOWNLOADS,
        defaultResponse: () => 'OK',
        delayMs: () => Math.random() * 1000,
    });

    protected onReset(): void {
        delayedDownloadingListItemFactory.resetCount();
    }
}

export const downloadingsMock = new DownloadingsMock();

export function addDownloadingsMockApi(mockAdapter: MockAdapter): void {
    downloadingsMock.register(mockAdapter, { delay: true });
}
